import * as React from 'react';

export const useCalendarPageDiff = (error: string) => {
  // сколько страниц пользователь прокликал после того, как вылез тултип об ошибке
  const [calendarPageDiff, setCalendarPageDiff] = React.useState(0);

  // если показали тултип, считаем, сколько раз пролистнули календарь, чтобы
  // показывать тултип только если активна нужная страница календаря
  const handleNextClick = React.useCallback(() => {
    if (error) {
      setCalendarPageDiff(prev => prev + 1);
    } else {
      setCalendarPageDiff(0);
    }
  }, [error]);

  // если показали тултип, считаем, сколько раз пролистнули календарь, чтобы
  // показывать тултип только если активна нужная страница календаря
  const handlePrevClick = React.useCallback(() => {
    if (error) {
      setCalendarPageDiff(prev => prev - 1);
    } else {
      setCalendarPageDiff(0);
    }
  }, [error]);

  return { calendarPageDiff, handleNextClick, handlePrevClick };
};
